import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const FINANCE_VIEWS_VOCABULARIES = [
    vocabulary('payout.status', '@vello/ledger PAYOUT_STATUSES', {
        REQUESTED: L('Aguardando aprovação', 'Awaiting approval', 'Esperando aprobación', 'In attesa di approvazione'),
        PROCESSING: L('Em processamento', 'Processing', 'En proceso', 'In elaborazione'),
        PAID: L('Pago', 'Paid', 'Pagado', 'Pagato'),
        FAILED: L('Não pago', 'Not paid', 'No pagado', 'Non pagato'),
        REVERSED: L('Estornado', 'Reversed', 'Revertido', 'Stornato'),
    }),
    vocabulary('cash.shortfall_reason', '@vello/api-client CASH_SHORTFALL_REASON_CODES', {
        RIDER_REFUSED_TO_PAY: L('Passageiro recusou pagar', 'Rider refused to pay', 'El pasajero se negó a pagar', 'Il passeggero ha rifiutato di pagare'),
        RIDER_LEFT_WITHOUT_PAYING: L('Passageiro saiu sem pagar', 'Rider left without paying', 'El pasajero se fue sin pagar', 'Il passeggero se n’è andato senza pagare'),
        RIDER_NOT_ENOUGH_CASH: L('Passageiro sem dinheiro suficiente', 'Rider did not have enough cash', 'El pasajero no tenía suficiente efectivo', 'Il passeggero non aveva abbastanza contanti'),
        RIDER_DISPUTED_FARE: L('Passageiro contestou o valor', 'Rider disputed the fare', 'El pasajero disputó el valor', 'Il passeggero ha contestato la tariffa'),
    }),
    vocabulary('refund.approval_status', '@vello/api-client REFUND_APPROVAL_STATUSES', {
        EXECUTED: L('Executado', 'Executed', 'Ejecutado', 'Eseguito'),
        PENDING: L('Aguardando aprovação', 'Awaiting approval', 'Esperando aprobación', 'In attesa di approvazione'),
        APPROVED: L('Aprovado', 'Approved', 'Aprobado', 'Approvato'),
        REJECTED: L('Rejeitado', 'Rejected', 'Rechazado', 'Rifiutato'),
        WITHDRAWN: L('Retirado', 'Withdrawn', 'Retirado', 'Ritirato'),
    }),
    vocabulary('safety.incident_type', '@vello/api-client SafetyIncidentType', {
        SOS: L('Pedido de socorro', 'Emergency (SOS)', 'Pedido de auxilio', 'Richiesta di soccorso'),
        HARASSMENT: L('Assédio', 'Harassment', 'Acoso', 'Molestie'),
        ACCIDENT: L('Acidente', 'Accident', 'Accidente', 'Incidente'),
        UNSAFE_DRIVING: L('Direção perigosa', 'Unsafe driving', 'Conducción peligrosa', 'Guida pericolosa'),
        ROUTE_CONCERN: L('Problema com a rota', 'Route concern', 'Problema con la ruta', 'Problema con il percorso'),
        LOST_ITEM: L('Objeto perdido', 'Lost item', 'Objeto perdido', 'Oggetto smarrito'),
        OTHER: L('Outro', 'Other', 'Otro', 'Altro'),
    }),
    vocabulary('safety.share_scope', '@vello/api-client ShareScope', {
        LOCATION: L('Localização', 'Location', 'Ubicación', 'Posizione'),
        ROUTE: L('Rota', 'Route', 'Ruta', 'Percorso'),
        DRIVER_IDENTITY: L('Identidade do motorista', 'Driver identity', 'Identidad del conductor', 'Identità dell’autista'),
        ETA: L('Hora de chegada', 'Arrival time', 'Hora de llegada', 'Orario di arrivo'),
        PLATE: L('Placa do veículo', 'Vehicle plate', 'Placa del vehículo', 'Targa del veicolo'),
    }),
    vocabulary('widget.embed_status', '@vello/api-client CredentialState', {
        ACTIVE: L('Ativo', 'Active', 'Activo', 'Attivo'),
        REVOKED: L('Revogado', 'Revoked', 'Revocado', 'Revocato'),
    }),
    // D625: who the widget visitor is (the Central queue) and what it is about (one list per audience).
    vocabulary('widget.audience', '@vello/api-client WidgetAudience', {
        customer: L('Sou cliente', 'I am a customer', 'Soy cliente', 'Sono un cliente'),
        driver: L('Sou motorista ou entregador', 'I am a driver or courier', 'Soy conductor o repartidor', 'Sono un autista o un corriere'),
        candidate: L('Quero ser motorista ou entregador', 'I want to drive or deliver', 'Quiero ser conductor o repartidor', 'Voglio diventare autista o corriere'),
        partner: L('Empresa ou loja parceira', 'Partner company or store', 'Empresa o tienda aliada', 'Azienda o negozio partner'),
    }),
    vocabulary('widget.topic', '@vello/api-client WidgetTopic', {
        ride: L('Uma corrida', 'A ride', 'Un viaje', 'Una corsa'),
        food: L('Um pedido de comida', 'A food order', 'Un pedido de comida', 'Un ordine di cibo'),
        send: L('Um envio', 'A delivery', 'Un envío', 'Una spedizione'),
        payment: L('Pagamento ou cobrança', 'Payment or charge', 'Pago o cobro', 'Pagamento o addebito'),
        lost_item: L('Esqueci algo no carro', 'I left something in the car', 'Olvidé algo en el auto', "Ho dimenticato qualcosa nell'auto"),
        account: L('Minha conta e acesso', 'My account and sign-in', 'Mi cuenta y acceso', 'Il mio account e accesso'),
        trip: L('Uma corrida ou entrega', 'A ride or delivery', 'Un viaje o una entrega', 'Una corsa o una consegna'),
        earnings: L('Ganhos e repasses', 'Earnings and payouts', 'Ganancias y pagos', 'Guadagni e pagamenti'),
        document: L('Documentos e cadastro', 'Documents and registration', 'Documentos y registro', 'Documenti e registrazione'),
        rider: L('Um passageiro ou cliente', 'A rider or customer', 'Un pasajero o cliente', 'Un passeggero o cliente'),
        signup: L('Como me cadastrar', 'How to sign up', 'Cómo registrarme', 'Come registrarmi'),
        signup_status: L('Andamento do meu cadastro', 'My sign-up status', 'Estado de mi registro', 'Stato della mia registrazione'),
        partnership: L('Quero ser parceiro', 'I want to become a partner', 'Quiero ser aliado', 'Voglio diventare partner'),
        store: L('Minha loja e pedidos', 'My store and orders', 'Mi tienda y pedidos', 'Il mio negozio e gli ordini'),
        payout: L('Pagamentos e repasses', 'Payments and payouts', 'Pagos y liquidaciones', 'Pagamenti e liquidazioni'),
    }),
    vocabulary('widget.position', '@vello/api-client WidgetPosition', {
        right: L('Canto direito', 'Right corner', 'Esquina derecha', 'Angolo destro'),
        left: L('Canto esquerdo', 'Left corner', 'Esquina izquierda', 'Angolo sinistro'),
    }),
    vocabulary('fleet.roster_document_status', '@vello/fleet-settlement DocStatus', {
        expired: L('Vencido', 'Expired', 'Vencido', 'Scaduto'),
        missing: L('Ausente', 'Missing', 'Ausente', 'Mancante'),
        expiring: L('Vencendo', 'Expiring', 'Por vencer', 'In scadenza'),
        valid: L('Válido', 'Valid', 'Válido', 'Valido'),
    }),
    vocabulary('fleet.payout_discrepancy', '@vello/fleet-settlement DiscrepancyCode', {
        AMOUNT_MISMATCH: L('Valor diferente do esperado', 'Amount differs from expected', 'Importe distinto del esperado', 'Importo diverso da quello atteso'),
        MISSING_PAYOUT: L('Repasse que não chegou', 'Payout that did not arrive', 'Liquidación que no llegó', 'Liquidazione non arrivata'),
        UNEXPECTED_PAYOUT: L('Repasse inesperado', 'Unexpected payout', 'Liquidación inesperada', 'Liquidazione inattesa'),
    }),
    vocabulary('ledger.entry_direction', '@vello/ledger EntryDirection', {
        DEBIT: L('Débito', 'Debit', 'Débito', 'Addebito'),
        CREDIT: L('Crédito', 'Credit', 'Crédito', 'Accredito'),
    }),
    vocabulary('ledger.account_class', '@vello/ledger ACCOUNT_CLASSES', {
        ASSET: L('Ativo', 'Asset', 'Activo', 'Attività'),
        LIABILITY: L('Passivo', 'Liability', 'Pasivo', 'Passività'),
        REVENUE: L('Receita', 'Revenue', 'Ingreso', 'Ricavo'),
        CONTRA_REVENUE: L('Redutora de receita', 'Contra-revenue', 'Reductora de ingresos', 'Rettifica di ricavo'),
        PROMOTIONAL: L('Promocional', 'Promotional', 'Promocional', 'Promozionale'),
    }),
    vocabulary('finance.merchant_payout_state', '@vello/merchant-finance PayoutState; @vello/food-settlement PayoutState', {
        pending: L('Pendente', 'Pending', 'Pendiente', 'In sospeso'),
        paid: L('Pago', 'Paid', 'Pagado', 'Pagato'),
        failed: L('Falhou', 'Failed', 'Falló', 'Non riuscito'),
    }),
    vocabulary('finance.settlement_kind', '@vello/food-settlement SettlementKind', {
        order: L('Pedido', 'Order', 'Pedido', 'Ordine'),
        refund: L('Reembolso', 'Refund', 'Reembolso', 'Rimborso'),
        chargeback: L('Estorno (chargeback)', 'Chargeback', 'Contracargo', 'Chargeback'),
    }),
    vocabulary('finance.settlement_party', '@vello/food-settlement PARTY_ORDER', {
        merchant: L('Loja', 'Merchant', 'Comercio', 'Esercente'),
        courier: L('Entregador', 'Courier', 'Repartidor', 'Corriere'),
        platform: L('Plataforma', 'Platform', 'Plataforma', 'Piattaforma'),
        promotional: L('Promocional', 'Promotional', 'Promocional', 'Promozionale'),
    }),
];
//# sourceMappingURL=finance-views.js.map